/** Tree readiness prefixes descendant IDs while FORM_REQUIRED keeps a role suffix. */
export function readinessIssue(value: string): { code: string; unitId?: string } {
  const parts = value.split(":");
  const index = parts.findIndex(part => /^(?:EVENT_|VOTING_POLICY_|FORM_|SCHEDULE_|ENTRY_|ENTRIES_|RESULT_)/.test(part));
  if (index <= 0) return { code: value };
  const unitId = parts[index - 1];
  return { code: parts.slice(index).join(":"), ...(/^[A-Za-z0-9][A-Za-z0-9_.-]{0,95}$/.test(unitId) ? { unitId } : {}) };
}
